import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { IDefaultGD, IDefaultDataGD, IDefaultDataAddGD, IDefaultDataUpdateGD } from '../models/defaultGD';
import { GestionDispositivosToolsService } from '../services/gestionDispositivosTools.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
/*import xlsx from 'xlsx/xlsx';*/
import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import ICredencialUsuario from '../models/credencial';
import { AuthService } from '../services/auth.service';
import { empty } from 'rxjs';
import { GestionAseguradorasToolService } from '../services/gestionAseguradoras.service';
import { IAseguradorasSCT, IDefaultDataUpdateEnsurance } from '../models/ensurence';
import { IEnsuranceSCTUpdt } from '../models/ensuranceUpd';

@Component({
  selector: 'app-lstaseguradoras',
  templateUrl: './lstaseguradoras.component.html',
  styleUrls: ['./lstaseguradoras.component.scss']
})
export class LstaseguradorasComponent {
  @ViewChild('dt1') dt!: Table;
  lstTool: Array<IDefaultDataGD> = [];
  dataGetIt: IDefaultGD = { status: false, data: []};
  loading: boolean = false;
  dspProc: boolean = false;
  ToolForm!: FormGroup;
  texto_operacion: string = '';
  num_operacion: number = 0;
  color_gris_deshabilitadas: string = '#D9D9D9';
  fecha_dia: string = new Date().toLocaleDateString('es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' });

  //Permisos
  user: ICredencialUsuario = {};
  constructor(private router: Router,
    private confirmationService: ConfirmationService, private messageService: MessageService,
    private gestionAseguradoraService: GestionAseguradorasToolService,private auth: AuthService) {
      this.cargarInformacionUsuario();
  }

  ngOnInit(): void {
    this.getListaAseguradoras();
    //this.crearFormularioHerramienta();
  }

  cargarInformacionUsuario(){
    this.user = this.auth.user;
  }

  getListaAseguradoras() {
    this.loading=true;
    this.gestionAseguradoraService.getListadoAseguradoras().subscribe((resp) => {
      if (resp.status) {
        this.lstTool = resp.data
      }

      this.loading=false;
    },
    (error)=> {
      this.loading=false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Herramientas');
    });
  }

  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  // crearFormularioHerramienta() {
  //   this.ensuranceForm = new FormGroup({
  //     id: new FormControl(),
  //     nombre: new FormControl('', [Validators.required],),
  //     nroPoliza: new FormControl('',[Validators.required]),
  //     id_procs: new FormControl({ value: 0, disabled: true }, [],),
  //     estado: new FormControl()
  //   });
  // }

  // guardarInformacionDeHerramienta() {
  //   if (this.num_operacion == 1) {
  //     let data_enviar: IDefaultDataAddGD = {
  //       name: this.ToolForm.get('nombre')?.value,
  //       desc: this.ToolForm.get('descripcion')?.value,
  //       user: this.user.cod == undefined ? '0001' : this.user.cod
  //     };

  //     this.gestionDispositivosService.saveHerramienta(data_enviar).subscribe((resp) => {
  //       if (resp.status) {
  //         setTimeout(() => {
  //           this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
  //           this.ToolForm.reset();
  //           this.cancelarVentanaModal();
  //           this.getListaDeHerramienta();
  //         }, 800);
  //       } else {
  //         this.messageService.add({ severity: 'error', summary: 'Error en <Agregar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
  //       }
  //     },
  //       (error) => {
  //         this.messageService.add({ severity: 'error', summary: 'Error en <Agregar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
  //       });
  //   } else
  //     if (this.num_operacion == 2) {
  //       let data_enviar: IDefaultDataUpdateGD = {
  //         id: this.ToolForm.get('id')?.value,
  //         name: this.ToolForm.get('nombre')?.value,
  //         desc: this.ToolForm.get('descripcion')?.value,
  //         user: this.user.cod == undefined ? '0001' : this.user.cod,
  //         state: this.ToolForm.get('estado')?.value
  //       };

  //       this.gestionDispositivosService.editHerramienta(data_enviar).subscribe((resp) => {
  //         if (resp.status) {
  //           setTimeout(() => {
  //             this.messageService.add({ severity: 'success', summary: 'Registro Actualizado', detail: 'La informacion se actualizo de forma correcta' });
  //             this.ToolForm.reset();
  //             this.cancelarVentanaModal();
  //             this.getListaDeHerramienta();
  //           }, 800);
  //         } else {
  //           this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
  //         }
  //       },
  //         (error) => {
  //           this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
  //         });
  //     }
  // }

  mostrarModalAgregar() {
    this.cancelarVentanaModal();
    this.num_operacion = 1;
    this.dspProc = true;
    this.texto_operacion = 'Agregar Nueva Aseguradora';
  }

  mostrarModalEditar(herramienta: IDefaultDataGD) {
    this.ToolForm.controls['id'].setValue(herramienta.id);
    this.ToolForm.controls['nombre'].setValue(herramienta.nombre);
    this.ToolForm.controls['descripcion'].setValue(herramienta.descripcion);
    this.num_operacion = 2;
    this.dspProc = true;
    this.texto_operacion = 'Editar Herramienta';
  }

  cancelarVentanaModal() {
    this.num_operacion = 0;
    this.dspProc = false;
    this.texto_operacion = '';
    this.ToolForm.reset();
  }

  cambiaEstatus(dataDel: IAseguradorasSCT) {
   let estatus_original= dataDel.activo;
    let texto_desactivar: string = dataDel.activo == 0 ? 'DESACTIVAR' : 'ACTIVAR';
    let texto_desactivar_header: string = dataDel.activo == 0 ? 'Desactivar' : 'Activar';
    
    this.confirmationService.confirm({
      message: 'Esta seguro que desea ' + texto_desactivar + ' el registro del Herramienta ' + dataDel.nombre_aseguradora + '?',
      header: 'Confirmacion de ' + texto_desactivar_header,
      icon: 'pi pi-info-circle',
      accept: () => {
        // const data: IDefaultDataUpdateEnsurance = {  id: 0, activo: 0, user: ''}
        // data.id = Number(dataDel.id);
        dataDel.id = Number(dataDel.id)
        dataDel.activo = dataDel.activo == 1 ? 0 : 1
        dataDel.user = this.user.cod == undefined ? '0001' : this.user.cod
        
        this.updateInformacionDesactivar(dataDel);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            dataDel.activo = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
            break;
          case ConfirmEventType.CANCEL:
            dataDel.activo = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
            break;
        }
      }
    });
  }

  updateInformacionDesactivar(data: IAseguradorasSCT) {
    let comAseg: IEnsuranceSCTUpdt = {
      id: data.id.toString(),
      nombreAseguradora: data.nombre_aseguradora,
      tipo: data.tipo,
      nroPoliza: data.nro_poliza,
      fechaIniVigencia: data.fecha_ini_vigencia,
      fechaFinVigencia: data.fecha_fin_vigencia,
      aseguradoRazonSocial: data.asegurado_razon_social,
      aseguradoRfc: data.asegurado_rfc,
      activo: data.activo==1? 0:1,
      user: this.user.cod!
    }
    this.gestionAseguradoraService.editAseguradora(comAseg).subscribe((resp) => {
      if (resp.status) {
        setTimeout(() => {
          this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
          this.ToolForm.reset();
          //this.cancelarVentanaModal();
          this.getListaAseguradoras();
        }, 800);
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
      }
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    //var FileSaver = require('file-saver');
    var getYear = new Date().toLocaleDateString('es-MX',{ year: 'numeric'});
    var getMonth = new Date().toLocaleDateString('es-MX',{ month: '2-digit'});
    var getDay = new Date().toLocaleDateString('es-MX',{day: '2-digit'});
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_export_" + dateFormat + EXCEL_EXTENSION);

  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario:string){
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({key: 'msj',severity:'info', summary:'Confirmación', detail:'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({key: 'msj',severity:'info', summary:'Confirmación', detail:'Usuario informado de la situación.'});
      },
      key: "sinInformacionDialog"
  });
  }

}
